export default {
  props: {
    processList: {
      type: Array,
      default() { return [];}
    },
    itemWidth: {
      type: String,
      default: '300px'
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
};
